/* eslint-disable */
import React, { memo, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import { SelectValidator } from 'react-material-ui-form-validator'
import { themeV5 } from 'theme/v5'

const getStyles = (name, selected, theme) => ({
  fontWeight:
    selected === name === -1
      ? themeV5.typography.fontWeightRegular
      : themeV5.typography.fontWeightMedium,
})

const SingleSelect = ({
  id,
  size,
  label,
  options,
  tight,
  value = '',
  onChange,
  disabled,
  numberOnly,
  noNone,
  ...rest
}) => {

  const [selected, setSelected] = useState(value)

  const onChangeSelection = event =>
    onChange(event.target.value)

  useEffect(() => {
    setSelected(value)
  }, [value])

  return (
    <SelectValidator
      sx={{
        ...(tight && {
          '& .MuiOutlinedInput-input': {
            paddingX: 2,
            paddingY: 1.6,
          },
          '& .MuiInputLabel-outlined': {
            transform: 'translate(14px, 14px) scale(1)',
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
          },
        })
      }}
      fullWidth
      size={size}
      disabled={disabled}
      label={label}
      variant="outlined"
      value={selected}
      inputProps={{
        id,
        name: label,
      }}
      onChange={onChangeSelection}
      {...rest}>
        
      { ! noNone && (
        <MenuItem value={numberOnly ? 0 : ''}>
          {numberOnly ? 0 : <em>None</em>} 
        </MenuItem>
      )}
      {options.map((option, index) => {

        const name = option.label || option
        const code = option.value || option

        if (option.label && ! option.value) {
          return (
            <MenuItem
              sx={{
                paddingTop: '2px !important',
                paddingBottom: '2px !important',
                minHeight: '0 !important',
                background: 'transparent !important',
              }}
              key={index}
              disabled
              value="">
              <em>{name}</em>
            </MenuItem>
          )
        }

        return (
          <MenuItem
            key={index}
            value={code}
            style={getStyles(code, selected, theme)}>
            {name}
          </MenuItem>
        )
      })}
    </SelectValidator>
  )
}


SingleSelect.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  tight: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.number,
  ]),
  validators: PropTypes.arrayOf(PropTypes.string),
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  numberOnly: PropTypes.bool,
  noNone: PropTypes.bool,
}

export default memo(SingleSelect)
